import React from 'react';
import { Animated } from 'react-native';

interface LoadingMessageProps {
    message: string;
    dots: string;
    fadeAnim: Animated.Value;
}

export const LoadingAnimation: React.FC<LoadingMessageProps> = ({ message, dots, fadeAnim }) => (
    <Animated.Text
        style={{
            fontSize: 15,
            fontWeight: '500',
            opacity: fadeAnim,
            fontFamily: 'Inter',
            color: '#60646C',
        }}
    >
        {message}
        {dots}
    </Animated.Text>
);